import Breadcrumb from "../components/Breadcrumb";
import Profile from "../components/Profile";
import ProfileLayer from "../components/ProfileLayer";
import Roles from "../components/Roles";

const ProfilePage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Profile" />

      {/*All Clients Layer*/}
      <ProfileLayer />
    </>
  );
};

export default ProfilePage;
